import { IsRegisteredData } from 'hooks/useIsAlreadyRegistered';

import { InvestorSubTypes, UserTypes } from '../constants/user';
import { capitalizeFirstLetter } from './global/global';

export const getDeletedShareExchangesMessage = (count: number) =>
  count > 1 ? 'The share exchanges were successfully deleted' : 'The share exchange was successfully deleted';

export const getAlreadyRegisteredEmailMessage = (
  userType: UserTypes,
  investorSubType: InvestorSubTypes,
  isAlreadyRegisteredData: IsRegisteredData | null,
) => {
  if (userType !== UserTypes.FOUNDER && userType !== UserTypes.INVESTOR) return;

  if (userType === UserTypes.INVESTOR && isAlreadyRegisteredData?.isFounder) {
    return 'Founder account already exists in the system please provide password to register Investor account ';
  }

  if (
    userType === UserTypes.INVESTOR &&
    investorSubType === InvestorSubTypes.ENTITY &&
    isAlreadyRegisteredData?.isIndividualInvestor
  ) {
    return 'Individual investor account already exists in the system please provide password to register Investor account ';
  }

  if (
    userType === UserTypes.INVESTOR &&
    investorSubType === InvestorSubTypes.INDIVIDUAL &&
    isAlreadyRegisteredData?.isEntityInvestor
  ) {
    return 'Entity investor account already exists in the system please provide password to register Investor account ';
  }

  if (userType === UserTypes.FOUNDER && isAlreadyRegisteredData?.isInvestor) {
    return 'Investor account already exists in the system please provide password to register Founder account ';
  }

  return 'Second account already exists in the system please provide password to register Founder account ';
};
